import React from 'react';
import { render } from 'react-dom';

import "./style.scss";
import App from './App';

render(
  <App />,
  document.getElementById('root')
);
